<script setup lang="ts">
import InputFile from './input-file.vue';

const props = defineProps<{
    buttonClass?: string;
    icon?: string;
    label?: string;
}>();
</script>
<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>
<template>
    <span class="btn fileinput-button" :class="props.buttonClass ?? 'btn-success'">
        <slot>
            <i v-if="props.icon" class="bi" :class="props.icon" />
            <span v-if="props.label">{{ props.label }}</span>
        </slot>
        <InputFile v-bind="$attrs" />
    </span>
</template>
